<template>
  <modal-default
    ref="modal"
    title="Cancel Appointment"
  >
    <div class="modal-inner">
      <form-field-select
        label="Cancel By"
        v-model="payload.cancellation_type"
      >
        <option
          v-for="(type, index) in ENUMS.AppointmentCancellationTypeEnum"
          v-show="type.label !== ENUMS.AppointmentCancellationTypeEnum.Unknown.label"
          :value="type.value"
          :key="index"
        >
          {{ type.label }}
        </option>
      </form-field-select>
    </div>

    <template v-slot:footer>
      <button-default @click="cancel" :loading="isLoading" :disabled="isLoading">
        Cancel
      </button-default>
    </template>
  </modal-default>
</template>

<script>
import {ENUMS} from "../services/enums";

export default {
  name: "AppointmentDeleteForm",
  data() {
    return {
      payload: {
        id: '',
        cancellation_type: ENUMS.AppointmentCancellationTypeEnum.Contact.value,
      },
      isLoading: false,
    }
  },
  methods: {
    open(form) {
      this.payload.id = form.id;
      this.$refs.modal.open();
      // mark edit appointment modal to open
      this.$store.commit('modals/openModal', 'editAppointment')
    },
    cancel() {
      this.isLoading = true;
      this.$api.appointments.cancel(this.payload)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Appointment was cancelled',
            type: 'is-success'
          });

          this.$refs.modal.close();
          // trigger edit appointment modal to close
          this.$store.commit('modals/closeModal', 'editAppointment')
        })
        .finally(() => this.isLoading = false);
    }
  }
}
</script>

<style scoped>

</style>
